/**
 * Every major provider now refuses a plain account password over IMAP and
 * requires an app-specific password with 2FA enabled. The hints below tell the
 * user exactly that, at the point where they'd otherwise get a cryptic
 * AUTHENTICATIONFAILED.
 */
export const PROVIDER_PRESETS = [
    {
        id: 'GMAIL',
        label: 'Gmail / Google Workspace',
        imapHost: 'imap.gmail.com',
        imapPort: 993,
        imapSecure: true,
        credentialHint: 'Requires a 16-character App Password (2-Step Verification must be on). Your normal Google password will not work.',
        helpUrl: 'https://myaccount.google.com/apppasswords',
        domains: ['gmail.com', 'googlemail.com'],
    },
    {
        id: 'OUTLOOK',
        label: 'Outlook / Hotmail / Microsoft 365',
        imapHost: 'outlook.office365.com',
        imapPort: 993,
        imapSecure: true,
        credentialHint: 'Requires an App Password. Many Microsoft 365 tenants disable basic IMAP auth entirely — check with your admin first.',
        helpUrl: 'https://account.live.com/proofs/AppPassword',
        domains: ['outlook.com', 'hotmail.com', 'live.com', 'msn.com'],
    },
    {
        id: 'YAHOO',
        label: 'Yahoo Mail',
        imapHost: 'imap.mail.yahoo.com',
        imapPort: 993,
        imapSecure: true,
        credentialHint: 'Requires an App Password generated from Yahoo Account Security.',
        helpUrl: 'https://login.yahoo.com/account/security',
        domains: ['yahoo.com', 'ymail.com', 'rocketmail.com'],
    },
    {
        id: 'ZOHO',
        label: 'Zoho Mail',
        imapHost: 'imap.zoho.com',
        imapPort: 993,
        imapSecure: true,
        credentialHint: 'Enable IMAP under Mail Settings, then generate an application-specific password.',
        helpUrl: 'https://accounts.zoho.com/home#security/apppasswords',
        domains: ['zoho.com', 'zohomail.com'],
    },
    {
        id: 'ICLOUD',
        label: 'iCloud Mail',
        imapHost: 'imap.mail.me.com',
        imapPort: 993,
        imapSecure: true,
        credentialHint: 'Requires an app-specific password from appleid.apple.com.',
        helpUrl: 'https://appleid.apple.com/account/manage',
        domains: ['icloud.com', 'me.com', 'mac.com'],
    },
    {
        id: 'CUSTOM',
        label: 'Custom IMAP server',
        imapHost: '',
        imapPort: 993,
        imapSecure: true,
        credentialHint: 'Enter the IMAP host and credentials supplied by your mail provider.',
        domains: [],
    },
];
export function presetForAddress(email) {
    const domain = email.split('@')[1]?.toLowerCase() ?? '';
    return (PROVIDER_PRESETS.find((p) => p.domains.includes(domain)) ??
        PROVIDER_PRESETS[PROVIDER_PRESETS.length - 1]);
}
//# sourceMappingURL=providers.js.map